module.exports = __webpack_public_path__ + "img/section23.0794640d.png";